const API_BASE = process.env.REACT_APP_API_URL || "";

export async function fetchDistinctExamSubjects() {
  const res = await fetch(`${API_BASE}/api/admissions/distinct-exam-subjects`);
  if (!res.ok) throw new Error("Failed to fetch exam subjects");
  const data = await res.json();
  return data.subjects ?? [];
}

export async function fetchDistinctOfstedGrades() {
  const res = await fetch(`${API_BASE}/api/schools/distinct-ofsted-grades`);
  if (!res.ok) throw new Error("Failed to fetch Ofsted grades");
  const data = await res.json();
  return data.grades ?? [];
}

export async function fetchFilterMeta() {
  const res = await fetch(`${API_BASE}/api/schools/filter-meta`);
  if (!res.ok) throw new Error("Failed to fetch filter metadata");
  const data = await res.json();
  return {
    ofstedBySchoolId: data.ofstedBySchoolId ?? {},
    examSubjectsBySchoolId: data.examSubjectsBySchoolId ?? {},
    gcseBySchoolId: data.gcseBySchoolId ?? {},
    ks5BySchoolId: data.ks5BySchoolId ?? {},
  };
}
